import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Single-store picker for the store-scoped pre-built reports.
// PrebuiltReportsDisplay owns the selection state and passes the rendered
// element down through each report into the shell's filter row, so every
// report gets the same control without duplicating state or fetch logic —
// reports keep reading the `homeStore` prop, which the display swaps to the
// picked store. Hidden (renders null) for single-store users.
//
// labelPosition matches the host report's filter idiom: "inline" for the
// single-height rows (DateSelector / WeekSelector reports), "top" for the
// reports whose filters stack a small label above each input (Punch
// Information, Log Entries by Type) so the controls bottom-align.
export default function ReportStorePicker({
  storeNames,
  value,
  onChange,
  labelPosition = "inline",
}) {
  if (!Array.isArray(storeNames) || storeNames.length < 2) return null;

  const select = (
    <Select
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      sx={{
        height: "36px",
        backgroundColor: "white",
        fontSize: "13px",
        borderRadius: "6px",
        minWidth: "160px",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#6d28d9",
        },
      }}
    >
      {storeNames.map((s) => (
        <MenuItem key={s.id} value={s.id} dense>
          {s.store_name}
        </MenuItem>
      ))}
    </Select>
  );

  if (labelPosition === "top") {
    return (
      <div>
        <div className="text-xs text-slate-500 mb-1">Store</div>
        {select}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-slate-500">Store</label>
      {select}
    </div>
  );
}
